import React from 'react';
import {Button, Heading, SubHeading,} from './TripDatesModal.style';
import StyledDateTimePicker from "../../components/DateRangePickerWrapper/StyledDateTimePicker";

export default function TripDatesModal({onOk, deviceType = null, ...props}) {


    return (
        <div className="rounded-lg text-center">
            <div className="p-4 pt-6 sm:p-10 sm:pt-10 rounded-lg ">
                <Heading>
                    Welcome!
                </Heading>
                <p className="text-gray-700 font-semibold my-4">Please select your trip dates</p>
                <StyledDateTimePicker
                    heading={false}
                    showResetDates={false}
                    numberOfMonths={deviceType?.desktop ? 2 : 1}
                    {...props}
                />
                <SubHeading>
                    Please select your trip dates to filter for available products
                </SubHeading>

                <Button
                    fullwidth
                    title={'Continue'}
                    onClick={onOk}
                />
                <div className="mt-5 sm:mt-6 ">
                     <span className="flex w-full rounded-md shadow-sm">
                          <button type="button"
                                  onClick={onOk}
                                  className="inline-flex justify-center w-full items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
                           I'll do this later
                          </button>
                        </span>
                </div>
            </div>
        </div>
    );
}
